
export enum SceneSubPathType {
    Profile,
    Replay,
    GiftUser,
}

interface SubPathPattern {
    name: SceneSubPathType
    pattern: RegExp
    extractData: (href: string) => string[] | undefined
}

const PROXY_PREFIX = '/.proxy'

const validPaths = [
    '/',
    '/disable-ad-block',
    '/dist',
]

const validSceneSubPaths: SubPathPattern[] = [
    {
        name: SceneSubPathType.Profile,
        pattern: /^\/profile\/[^/]+(?:[#?].*)?$/,
        extractData: (href: string) => {
            const match = href.match(/^\/profile\/([^#?]+)/)
            if(!match) return undefined

            const decodedUsername = decodeURIComponent(match[1])
            return [decodedUsername]
        },
    },
    {
        name: SceneSubPathType.Replay,
        pattern: /^\/replay\?gameId=\d+&playerColor=\d+$/,
        extractData: (href: string) => {
            const url = new URL(href, 'https://colonist.io')
            const gameId = url.searchParams.get('gameId')
            const playerColor = url.searchParams.get('playerColor')
            return (gameId && playerColor) ? [gameId, playerColor] : undefined
        },
    },
    {
        name: SceneSubPathType.GiftUser,
        pattern: /^\/store(?:\?username=([\w-]+))?#gift$/,
        extractData: (href: string) => {
            const match = href.match(/^\/store(?:\?username=([\w-]+))?#gift$/)
            return match ? [match[1] ?? undefined] : undefined
        },
    },

]

const validPathPatterns = validPaths.map((link) => {
    if(link === '/') return new RegExp(`^(${PROXY_PREFIX})?\\/$`)
    return new RegExp(`^(${PROXY_PREFIX})?` + link.replace(/\//g, '\\/') + '.*$')
})

export function isValidPath(href: string): boolean {
    return validPathPatterns.some((pattern) => pattern.test(href))
}

export function getValidSubPath(href: string): SubPathPattern | undefined {
    const matchedPath = validSceneSubPaths.find(({pattern}) => pattern.test(href))
    return matchedPath
}

const LANGUAGE_PREFIX_PATTERN = /^\/[a-z]{2}(?:-[A-Za-z]{2})?(?=\/)/

export function stripLanguagePrefix(href: string): string {
    return href.replace(LANGUAGE_PREFIX_PATTERN, '')
}

export function stripProxyPrefix(href: string): string {
    return href.startsWith(PROXY_PREFIX) ? href.slice(PROXY_PREFIX.length) : href
}
